// profile-token.ts — the shape of a profile token, and nothing else.
//
// A leaf module on purpose. `profile-api.ts` and `profile-store.ts` both need
// to validate a token. This file imports nothing, so both sides share the rule
// instead of keeping two copies of a regex that only have to drift once.
//
// Since #3025 profile-store no longer imports profile-crypto statically, so
// the leaf shape is no longer load-bearing for bundle size; it stays because the
// token rule still has exactly one home.

/** 16 bytes, hex — the shape the server's `derive_profile_token` produces. */
export const TOKEN_HEX_RE = /^[0-9a-f]{32}$/;
